export default __webpack_public_path__ + "static/media/Placeholder.b2d67550.jpg";